var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_STORE_ROUTES = 'api/storeRoutes';
const GET_ROUTE = 'api/routes';
export const closeStoreRoutes = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_STORE_ROUTES}/${storeId}/close`, data, config);
        }
        catch (error) {
            console.error('Error fetching closeStoreRoutes:', error);
            throw error;
        }
    });
};
export const closeRouteById = function (routeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_ROUTE}/${routeId}/close`, {}, config);
        }
        catch (error) {
            console.error('Error fetching closeRouteById:', error);
            throw error;
        }
    });
};
export const closeRouteByIdV2 = function (routeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_ROUTE}/${routeId}/close`, data || {}, config);
        }
        catch (error) {
            console.error('Error fetching closeRouteByIdV2:', error);
            throw error;
        }
    });
};
export const updateRouteById = function (routeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_ROUTE}/${routeId}`, data, config);
        }
        catch (error) {
            console.error('Error fetching updateRouteById:', error);
            throw error;
        }
    });
};
